<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Upload files to sort -
            <template v-if="form._id">edit</template>
            <template v-if="!form._id">add new</template>
        </template>
        <fieldset class="mb-3" :class="{'loading-mask': loading}">
            <div class="alert alert-danger">
                <strong>
                    Upload files with at least 3 columns: <span style="text-decoration: underline">email, first_name and last_name</span> (in that order).
                    Files will be merged together and unique rows will be counted.
                </strong>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">CSV separator</label>
                <div class="col-lg-4">
                    <div class="form-check form-check-inline">
                        <multiselect v-model="separator" tag-placeholder="" placeholder="Choose separator" label="name" track-by="name" :options="separators" :multiple="false"></multiselect>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Files</label>
                <div class="col-lg-4">
                    <upload :onUploadCompleted="completed" :onUploadProgress="inprogress" :url="url" :multiple="true" :accept="'.csv, text/plain,text/csv,application/csv'" />
                </div>
            </div>
            <div class="alert alert-danger" v-if="err">{{err}}</div>
            <div class="form-group row">
                <label class="col-form-label col-lg-12">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                    <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                </label>
            </div>
        </fieldset>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'
import upload from '../common/FileUpload.vue'

export default {
    components: { modal, upload },
    props: {
        id: null,
    },
    data() {
        return {
            form: {
                _id: null,
                name: null
            },
            err: null,
            loading: false,
            separator:{name: 'tab'},
            separators: [
                { name: 'tab' },
                { name: '; (semicolon)' },
                { name: ', (comma)' },
            ]
        }
    },
    computed:{
        url: function(){

            let s = ''

            if(this.separator.name.indexOf('tab') === 0){
                s = 'tab'
            }
            if(this.separator.name.indexOf('comma') >= 0){
                s = 'comma'
            }
            if(this.separator.name.indexOf('semicolon') >= 0){
                s = 'semicolon'
            }

            return 'sorter?separator=' + (s)
        }
    },
    methods: {
        save() {
            this.loading = true
            this.$api.postReq('contact_list', this.form).then(res => {
                this.$emit('close')
                this.$emit('reload')
            }).catch(res => {
                this.err = res.body.error
            })
        },
        completed(res, body) {

            let blob = new Blob([body], { type: 'text/csv' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "sorted" + (new Date).getTime() + ".csv";
            link.click();
        },
        inprogress(res, body) {},
    },
    mounted() {

        if (typeof this.id !== 'string') {
            return
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/ListSorter.vue